import React, {useEffect, useState} from "react";
import classes from "./auth.module.css";
import ErrorText from "../errors/ErrorText";

const LoginForm = ({isLoginModal, setLoginModal, handleLogin}) => {

    const [isAnimating, setIsAnimating] = useState(false);
    const [login, setLogin] = useState('')
    const [password, setPassword] = useState('')
    const [error, setError] = useState("");

    useEffect(() => {
        if (!isLoginModal) {
            return false;
        }
        const handleEnter = async (e) => {
            if (e.key === "Enter") {
                await handleSubmit()
            }
        }
        window.addEventListener('keydown', handleEnter);
        return () => {
            window.removeEventListener('keydown', handleEnter)
        };
    })

    if (!isLoginModal) return null;

    async function handleSubmit() {
        try {
            setIsAnimating(true);
            setError("");
            await handleLogin(login, password);
        } catch (err) {
            console.error("Ошибка авторизации:", err);
            setError(err?.message || "Неверный логин или пароль");
        } finally {
            setIsAnimating(false);
        }
    }


    return (
        <div className={` ${classes.overlay}`} onClick={() => setLoginModal(false)}>
            <div className={` ${classes.modal}`} onClick={(e) => e.stopPropagation()}>
                <div className={classes.close} onClick={() => setLoginModal(false)}>
                    ✖
                </div>

                <h3 className={classes.title}>Вход</h3>

                <input
                    type="text"
                    placeholder="Логин"
                    className={classes.input}
                    onChange={(e) => setLogin(e.target.value)}/>
                <input
                    type="password"
                    placeholder="Пароль"
                    className={classes.input}
                    onChange={(e) => setPassword(e.target.value)}/>
                {error && (
                    <div>
                        <ErrorText text={error}
                                   className={classes.errorText}></ErrorText>
                    </div>
                )}
                <button
                    className={`${classes.submit} ${isAnimating ? classes.loading : ""}`}
                    onClick={handleSubmit}
                    disabled={isAnimating || login.length === 0 || password.length === 0}
                >
                    {isAnimating ?

                        <svg width="24" height="24" viewBox="0 0 50 50">
                            <circle
                                cx="25"
                                cy="25"
                                r="20"
                                stroke="rgba(255,255,255,0.2)"
                                stroke-width="4"
                                fill="none"
                            />
                            <circle
                                cx="25"
                                cy="25"
                                r="20"
                                stroke="#fff"
                                stroke-width="4"
                                fill="none"
                                stroke-dasharray="30 94"
                                stroke-linecap="round"
                            >
                                <animateTransform
                                    attributeName="transform"
                                    type="rotate"
                                    values="0 25 25;180 25 25;0 25 25"
                                    dur="1.5s"
                                    repeatCount="indefinite"
                                    calcMode="spline"
                                    keyTimes="0;0.5;1"
                                    keySplines="0.42 0 0.58 1;0.42 0 0.58 1"
                                />
                            </circle>
                        </svg>

                        : "Войти"}
                </button>
            </div>
        </div>
    );
};

export default LoginForm;